/* Warsupps teması — tüm etkileşimler ve animasyon tetikleyicileri */
(function () {
  'use strict';
  var W = window.WAR || {};
  var body = document.body;

  /* ---------- yardımcılar ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 2600);
  }
  function money(cents) {
    var fmt = W.moneyFormat || '{{amount}} TL';
    var v = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: fmt.indexOf('no_decimals') > -1 ? 0 : 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---------- kaydırırken belirme ---------- */
  function reveal() {
    if (!body.classList.contains('reveal-on')) return;
    if (!('IntersectionObserver' in window)) { $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- mobil menü ---------- */
  function menu() {
    var btn = $('[data-menu-toggle]'), panel = $('[data-menu]');
    on(btn, 'click', function () { panel.hidden = !panel.hidden; });
  }

  /* ---------- öngörülü arama ---------- */
  function search() {
    $$('[data-search]').forEach(function (wrap) {
      var input = $('input', wrap), panel = $('[data-search-panel]', wrap), t;
      if (!input || !panel) return;
      function close() { panel.hidden = true; panel.innerHTML = ''; }
      on(input, 'input', function () {
        var q = input.value.trim();
        clearTimeout(t);
        if (q.length < 2) { close(); return; }
        t = setTimeout(function () {
          var url = (W.routes.predictive || '/search/suggest') + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
          fetch(url).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('[data-predictive-results]');
            panel.innerHTML = res ? res.innerHTML : '';
            panel.hidden = false;
          }).catch(close);
        }, 220);
      });
      on(document, 'click', function (e) { if (!wrap.contains(e.target)) close(); });
      on(input, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- banner slider ---------- */
  function hero() {
    var root = $('[data-hero]'); if (!root) return;
    var slides = $$('[data-hero-slide]', root), dots = $$('[data-hero-dot]', root), i = 0, timer;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        if (k === i) {
          s.style.display = 'block';
          requestAnimationFrame(function () { s.classList.add('is-active'); });
        } else {
          s.classList.remove('is-active');
          s.style.display = 'none';
        }
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (root.dataset.autoplay === 'true') { stop(); timer = setInterval(function () { go(i + 1); }, parseInt(root.dataset.interval || '6000', 10)); } }
    function stop() { clearInterval(timer); }
    on($('[data-hero-prev]', root), 'click', function () { go(i - 1); start(); });
    on($('[data-hero-next]', root), 'click', function () { go(i + 1); start(); });
    dots.forEach(function (d, k) { on(d, 'click', function () { go(k); start(); }); });
    on(root, 'mouseenter', stop); on(root, 'mouseleave', start);
    var x0 = null;
    on(root, 'touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    on(root, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
      x0 = null; start();
    });
    start();
  }

  /* ---------- oklu yatay sıralar ---------- */
  function rows() {
    $$('[data-row]').forEach(function (row) {
      var wrap = row.closest('[data-rowwrap]') || row.parentNode;
      var prev = $('[data-row-prev]', wrap), next = $('[data-row-next]', wrap);
      function step(dir) {
        var card = row.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 18 : row.clientWidth * 0.8;
        row.scrollBy({ left: dir * w * (window.innerWidth > 1100 ? 2 : 1), behavior: 'smooth' });
      }
      on(prev, 'click', function () { step(-1); });
      on(next, 'click', function () { step(1); });
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.hidden = max <= 0;
        if (next) next.hidden = max <= 0;
      }
      on(row, 'scroll', sync); on(window, 'resize', sync); sync();
    });
  }

  /* ---------- popüler ürünler sekmeleri ---------- */
  function tabs() {
    $$('[data-tabs]').forEach(function (root) {
      var btns = $$('[data-tab]', root), panes = $$('[data-tab-pane]', root);
      btns.forEach(function (b) {
        on(b, 'click', function () {
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          panes.forEach(function (p) { p.hidden = p.dataset.tabPane !== b.dataset.tab; });
        });
      });
    });
  }

  /* ---------- akordeon ---------- */
  function accordions() {
    $$('[data-acc]').forEach(function (acc) {
      var btn = $('[data-acc-btn]', acc), pane = $('[data-acc-body]', acc);
      on(btn, 'click', function () {
        var open = acc.classList.toggle('is-open');
        pane.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- adet ---------- */
  function qtyWidgets() {
    $$('[data-qty]').forEach(function (w) {
      var input = $('input', w) || $('[data-qty-val]', w);
      function val() { return parseInt((input.value || input.textContent || '1'), 10) || 1; }
      function set(v) {
        v = Math.max(1, v);
        var qm = parseInt(input.getAttribute && input.getAttribute('data-qmax') || '0', 10);
        if (qm > 0 && v > qm) { v = qm; toast('Stokta en fazla ' + qm + ' adet var.'); }
        if ('value' in input && input.tagName === 'INPUT') { input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); }
        else input.textContent = v;
      }
      on($('[data-qty-dec]', w), 'click', function () { set(val() - 1); });
      on($('[data-qty-inc]', w), 'click', function () { set(val() + 1); });
    });
  }

  /* ---------- sepet ---------- */
  function openDrawer() {
    var d = $('[data-cart-drawer]'), o = $('[data-cart-overlay]');
    if (!d) { window.location.href = W.routes.cart; return; }
    d.hidden = false; if (o) o.hidden = false;
    body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('[data-cart-drawer]'), o = $('[data-cart-overlay]');
    if (d) d.hidden = true; if (o) o.hidden = true;
    body.style.overflow = '';
  }
  function refreshCart(open) {
    return fetch('/?sections=cart-drawer,header')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parse = function (html, sel) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector(sel);
        };
        if (data['cart-drawer']) {
          var fresh = parse(data['cart-drawer'], '[data-cart-drawer]');
          var cur = $('[data-cart-drawer]');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        }
        if (data.header) {
          var fc = parse(data.header, '[data-cart-count]');
          var cc = $('[data-cart-count]');
          if (fc && cc) { cc.textContent = fc.textContent; cc.hidden = (parseInt(fc.textContent, 10) || 0) === 0; }
        }
        bindCart();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (open) openDrawer();
      });
  }
  function bindCart() {
    $$('[data-cart-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openDrawer(); }); });
    $$('[data-cart-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
    $$('[data-line-change]').forEach(function (b) {
      on(b, 'click', function () {
        var line = b.dataset.line, q = b.dataset.qty;
        b.disabled = true;
        fetch(W.routes.cartChange, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: q })
        }).then(function () { return refreshCart(false); }).catch(function () { toast(W.strings.error); });
      });
    });
  }
  function cartForms() {
    $$('form[action*="/cart/add"]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (form.dataset.noAjax === 'true') return;
        e.preventDefault();
        var btn = $('[type=submit]', form), label = btn ? btn.innerHTML : '';
        var buy = form.querySelector('[data-buy]');
        if ((btn && btn.disabled) || (buy && buy.dataset.soldout === 'true')) { toast('Bu ürün şu an stokta yok.'); return; }
        var qEl = form.querySelector('input[name="quantity"]');
        var qMax = qEl ? parseInt(qEl.getAttribute('data-qmax') || '0', 10) : 0;
        if (qMax === 0 && qEl && qEl.hasAttribute('data-qmax')) { toast('Bu ürün şu an stokta yok.'); return; }
        if (qMax > 0 && qEl && (parseInt(qEl.value, 10) || 1) > qMax) { qEl.value = qMax; toast('Stokta en fazla ' + qMax + ' adet var.'); return; }
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
        fetch(W.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/javascript' }, body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (d) { throw new Error((d && (d.description || d.message)) || ''); }, function () { throw new Error(''); });
            }
            return r.json();
          })
          .then(function () {
            if (btn) { btn.innerHTML = 'Sepete Eklendi ✓'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1400); }
            toast(W.strings.added);
            return refreshCart(true);
          })
          .catch(function (err) {
            toast((err && err.message) || W.strings.error);
            if (btn) { btn.innerHTML = label; btn.disabled = false; }
          });
      });
    });
  }

  /* ---------- ürün varyantları ---------- */
  function variants() {
    $$('[data-variants]').forEach(function (root) {
      var data = JSON.parse($('[data-variant-json]', root).textContent);
      var idInput = $('[data-variant-id]', root);
      var priceNow = $('[data-price-now]', root), priceWas = $('[data-price-was]', root);
      var addBtn = $('[data-add-btn]', root), stock = $('[data-stock]', root);
      var stockData = [];
      var sEl = $('[data-variant-stock-json]', root);
      if (sEl) { try { stockData = JSON.parse(sEl.textContent); } catch (e) { stockData = []; } }
      var qInput = root.querySelector('input[name="quantity"]');
      var buyBox = root.querySelector('[data-buy]');
      function applyStock(id) {
        var s = stockData.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!s) return;
        if (qInput) { qInput.setAttribute('data-qmax', s.max); qInput.max = s.max; if ((parseInt(qInput.value, 10) || 1) > s.max) qInput.value = Math.max(1, s.max); }
        if (buyBox) { if (s.available && s.max !== 0) delete buyBox.dataset.soldout; else buyBox.dataset.soldout = 'true'; }
      }
      $$('[data-opt]', root).forEach(function (b) {
        on(b, 'click', function () {
          $$('[data-opt]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          var v = data.filter(function (x) { return String(x.id) === b.dataset.opt; })[0];
          if (!v) return;
          idInput.value = v.id;
          if (priceNow) priceNow.textContent = money(v.price);
          if (priceWas) { priceWas.hidden = !(v.compare_at_price && v.compare_at_price > v.price); if (v.compare_at_price) priceWas.textContent = money(v.compare_at_price); }
          applyStock(v.id);
          var vimg = v.featured_image && (v.featured_image.src || v.featured_image);
          if (vimg) {
            var mainImg = $('[data-gallery-main]');
            if (mainImg) mainImg.src = vimg;
            var key = String(vimg).split('?')[0].split('/').pop();
            $$('[data-gallery-thumb]').forEach(function (t) {
              var tk = String(t.dataset.galleryThumb).split('?')[0].split('/').pop();
              t.classList.toggle('is-active', tk === key);
            });
          }
          var sv = stockData.filter(function (x) { return String(x.id) === String(v.id); })[0];
          var buyable = v.available && !(sv && sv.max === 0);
          if (addBtn) { addBtn.disabled = !buyable; addBtn.textContent = buyable ? 'Sepete Ekle' : 'Stokta Yok'; }
          if (stock) stock.hidden = !buyable;
          if (history.replaceState) history.replaceState({}, '', '?variant=' + v.id);
        });
      });
    });
  }

  /* ---------- galeri ---------- */
  function gallery() {
    var main = $('[data-gallery-main]'); if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (t) {
      on(t, 'click', function () {
        main.src = t.dataset.galleryThumb;
        $$('[data-gallery-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  /* ---------- yukarı çık ---------- */
  function toTop() {
    var b = $('#toTop'); if (!b) return;
    on(window, 'scroll', function () { b.hidden = (window.scrollY || 0) < 700; }, { passive: true });
    on(b, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- filtre otomatik gönderim ---------- */
  function filters() {
    $$('[data-filter-form]').forEach(function (form) {
      $$('input,select', form).forEach(function (el) {
        on(el, 'change', function () { form.submit(); });
      });
    });
  }

  /* ---------- kendi setini oluştur ---------- */
  function bundleBuilder() {
    var root = $('[data-bundle]'); if (!root) return;
    var tiers = [];
    try { tiers = JSON.parse(root.dataset.tiers || '[]'); } catch (e) { tiers = []; }
    var bar = $('[data-bundlebar]', root);
    (function catFilter() {
      var cats = $$('[data-bcat]', root), sInput = $('[data-bsearch]', root), nores = $('[data-bnores]', root);
      var grid = $('.bgrid', root), pager = $('[data-bpager]', root);
      var pnums = $('[data-bpnums]', root), pprev = $('[data-bprev]', root), pnext = $('[data-bnext-page]', root);
      if (!cats.length && !sInput && !pager) return;
      var active = '*', page = 1;
      var ROWS_D = parseInt(root.dataset.rows || '2', 10) || 2;
      var ROWS_M = parseInt(root.dataset.rowsMob || '4', 10) || 4;
      function rows() { return window.matchMedia('(max-width:760px)').matches ? ROWS_M : ROWS_D; }
      function norm(s) {
        return String(s || '').toLowerCase()
          .replace(/ı/g, 'i').replace(/İ/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g')
          .replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
          .replace(/[\s_]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').trim();
      }
      function cols() {
        if (!grid) return 4;
        var t = getComputedStyle(grid).gridTemplateColumns;
        var n = t && t !== 'none' ? t.split(' ').filter(Boolean).length : 0;
        return n > 0 ? n : 4;
      }
      function matches() {
        var q = norm(sInput && sInput.value || '');
        return $$('[data-bitem]', root).filter(function (card) {
          var tags = (card.dataset.tags || '').split('|').map(norm);
          var okCat = active === '*' || tags.indexOf(active) > -1;
          var okQ = !q || norm(card.dataset.search || '').indexOf(q) > -1;
          return okCat && okQ;
        });
      }
      function apply() {
        var list = matches();
        var per = Math.max(1, cols() * rows());
        var pages = Math.max(1, Math.ceil(list.length / per));
        if (page > pages) page = pages;
        var from = (page - 1) * per, to = from + per;
        $$('[data-bitem]', root).forEach(function (c) { c.hidden = true; });
        list.slice(from, to).forEach(function (c) { c.hidden = false; });
        if (nores) nores.hidden = list.length > 0;
        if (pager) {
          pager.hidden = pages < 2;
          if (pnums) {
            pnums.innerHTML = '';
            for (var i = 1; i <= pages; i++) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'bpage' + (i === page ? ' is-on' : '');
              b.textContent = i; b.dataset.goto = i;
              pnums.appendChild(b);
            }
          }
          if (pprev) pprev.disabled = page <= 1;
          if (pnext) pnext.disabled = page >= pages;
        }
      }
      function goTo(n) {
        page = Math.max(1, n);
        apply();
        if (grid) { var y = grid.getBoundingClientRect().top + window.pageYOffset - 120; window.scrollTo({ top: y, behavior: 'smooth' }); }
      }
      cats.forEach(function (b) {
        on(b, 'click', function () {
          active = norm(b.dataset.bcat || '*') || '*';
          if ((b.dataset.bcat || '*') === '*') active = '*';
          page = 1;
          cats.forEach(function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
          apply();
        });
      });
      if (pnums) on(pnums, 'click', function (e) {
        var b = e.target.closest('[data-goto]'); if (b) goTo(parseInt(b.dataset.goto, 10));
      });
      if (pprev) on(pprev, 'click', function () { goTo(page - 1); });
      if (pnext) on(pnext, 'click', function () { goTo(page + 1); });
      if (sInput) on(sInput, 'input', function () { page = 1; apply(); });
      on(window, 'resize', function () { clearTimeout(window.__bpT); window.__bpT = setTimeout(apply, 200); });
      apply();
    })();
    var hdr = $('.hdr');
    function measure() { if (hdr) document.documentElement.style.setProperty('--hdr-h', hdr.getBoundingClientRect().height + 'px'); }
    measure(); on(window, 'resize', measure);
    var cards = $$('[data-bitem]', root);
    var MAX = parseInt(root.dataset.max || '4', 10);
    var setIds = (root.dataset.setIds || '').split(',');
    var inCart = 0;
    function loadCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          inCart = 0;
          (c.items || []).forEach(function (i) {
            if (setIds.indexOf(String(i.id)) > -1) inCart += i.quantity;
          });
          render();
        })
        .catch(function () {});
    }
    function pctFor(n) { var p = 0; tiers.forEach(function (t) { if (n >= t.q) p = t.p; }); return p; }
    function nextTier(n) { for (var i = 0; i < tiers.length; i++) { if (tiers[i].q > n) return tiers[i]; } return null; }
    function state() {
      var n = 0, sum = 0;
      cards.forEach(function (c) {
        var q = parseInt(c.dataset.qty || '0', 10);
        if (q > 0) { n += q; sum += q * (parseInt(c.dataset.price, 10) || 0); }
      });
      return { n: n, sum: sum };
    }
    function render() {
      var s = state(), tot = s.n + inCart, pct = pctFor(tot), nt = nextTier(tot);
      var active = tot >= 4 ? 4 : tot;
      $$('[data-tier]', root).forEach(function (t) { t.classList.toggle('is-on', parseInt(t.dataset.tier, 10) === active); });
      var full = tot >= MAX;
      cards.forEach(function (c) {
        var q = parseInt(c.dataset.qty || '0', 10);
        var a = $('[data-badd]', c); if (a) a.disabled = full;
        var pl = $('[data-bplus]', c); if (pl) pl.disabled = full;
      });
      var mx = $('[data-bmax]', root);
      if (mx) {
        mx.hidden = !full;
        mx.innerHTML = inCart >= MAX
          ? 'Sepetinde zaten ' + inCart + ' set ürünü var — set doldu. <a href="' + W.routes.cart + '">Sepete git →</a>'
          : 'Bir sete en fazla ' + MAX + ' ürün ekleyebilirsin.';
      }
      var ic = $('[data-bincart]', root);
      if (ic) { ic.hidden = inCart === 0; ic.textContent = 'Sepetinde bu setten ' + inCart + ' ürün var.'; }
      if (bar) {
        bar.hidden = s.n === 0;
        var fill = Math.min(100, tot * 25);
        var f = $('[data-bfill]', bar); if (f) f.style.width = fill + '%';
        var sum = $('[data-bsum]', bar);
        if (sum) sum.textContent = inCart > 0 ? (inCart + ' sepette + ' + s.n + ' seçildi') : (s.n + ' ürün seçildi');
        var pe = $('[data-bpct]', bar); if (pe) { pe.hidden = pct === 0; pe.textContent = '%' + pct + ' indirim'; }
        bar.setAttribute('data-pct', pct);
        var nx = $('[data-bnext]', bar);
        if (nx) nx.textContent = nt ? (nt.q - tot) + ' ürün daha ekle, indirim %' + nt.p + ' olsun.' : 'En yüksek indirimdesin 🎯';
        var was = $('[data-bwas]', bar), now = $('[data-bnow]', bar);
        var fin = Math.round(s.sum * (100 - pct) / 100);
        if (now) now.textContent = money(fin);
        if (was) { was.hidden = pct === 0; was.textContent = money(s.sum); }
      }
    }
    function initCard(c) {
      var addBtn = $('[data-badd]', c), qtyBox = $('[data-bqty]', c), countEl = $('[data-bcount]', c);
      var vsel = $('[data-bvariant]', c), priceEl = $('[data-bprice]', c);
      c.dataset.qty = '0';
      function set(q) {
        q = Math.max(0, q);
        var other = inCart;
        cards.forEach(function (o) { if (o !== c) other += parseInt(o.dataset.qty || '0', 10); });
        if (other + q > MAX) q = Math.max(0, MAX - other);
        c.dataset.qty = q;
        c.classList.toggle('is-picked', q > 0);
        if (addBtn) addBtn.hidden = q > 0;
        if (qtyBox) qtyBox.hidden = q === 0;
        if (countEl) countEl.textContent = q;
        render();
      }
      on(addBtn, 'click', function () { set(1); });
      on($('[data-bplus]', c), 'click', function () { set(parseInt(c.dataset.qty, 10) + 1); });
      on($('[data-bminus]', c), 'click', function () { set(parseInt(c.dataset.qty, 10) - 1); });
      on(vsel, 'change', function () {
        var o = vsel.options[vsel.selectedIndex];
        c.dataset.id = o.value;
        c.dataset.price = o.dataset.price;
        if (priceEl) priceEl.textContent = money(parseInt(o.dataset.price, 10));
        render();
      });
    }
    cards.forEach(initCard);
    on($('[data-bsubmit]', root), 'click', function (e) {
      var btn = e.currentTarget, items = [];
      cards.forEach(function (c) {
        var q = parseInt(c.dataset.qty || '0', 10);
        if (q > 0) items.push({ id: parseInt(c.dataset.id, 10), quantity: q });
      });
      if (!items.length) return;
      btn.disabled = true; var label = btn.innerHTML; btn.innerHTML = '…';
      fetch(W.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          cards.forEach(function (c) {
            c.dataset.qty = '0'; c.classList.remove('is-picked');
            var a = $('[data-badd]', c), qb = $('[data-bqty]', c), ce = $('[data-bcount]', c);
            if (a) a.hidden = false; if (qb) qb.hidden = true; if (ce) ce.textContent = '1';
          });
          btn.innerHTML = label; btn.disabled = false;
          toast(W.strings.added);
          loadCart();
          return refreshCart(true);
        })
        .catch(function () { toast(W.strings.error); btn.innerHTML = label; btn.disabled = false; });
    });
    render();
    loadCart();
    (function topUp() {
      var handle = root.dataset.coll, grid = $('.bgrid', root);
      var rendered = parseInt(root.dataset.rendered || '0', 10);
      var total = parseInt(root.dataset.total || '0', 10);
      if (!handle || !grid || !cards.length || total <= rendered) return;
      var have = {};
      cards.forEach(function (c) { if (c.dataset.handle) have[c.dataset.handle] = 1; });
      var tpl = cards[0];
      function addPage(p) {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + p, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var list = (d && d.products) || [];
            list.forEach(function (pr) {
              if (have[pr.handle]) return;
              have[pr.handle] = 1;
              var vs = (pr.variants || []).filter(function (v) { return v.available; });
              if (!vs.length) return;
              var c = tpl.cloneNode(true);
              var v0 = vs[0];
              var price = Math.round(parseFloat(v0.price) * 100);
              c.dataset.id = v0.id; c.dataset.price = price; c.dataset.qty = '0';
              c.dataset.handle = pr.handle;
              c.dataset.tags = ((pr.tags || []).join('|') + '|' + (pr.product_type || '')).toLowerCase();
              c.dataset.search = (pr.title + ' ' + (pr.vendor || '') + ' ' + (pr.product_type || '')).toLowerCase();
              c.classList.remove('is-picked', 'is-out');
              c.hidden = true;
              $$('a[href]', c).forEach(function (a) { a.href = '/products/' + pr.handle; });
              var img = $('img', c), src = (pr.images && pr.images[0] && pr.images[0].src) || '';
              if (img) { if (src) { img.src = src.split('?')[0] + '?width=500'; img.srcset = ''; img.alt = pr.title; } else { img.remove(); } }
              var nm = $('.bcard__name', c); if (nm) nm.textContent = pr.title;
              var br = $('.bcard__brand', c); if (br) br.textContent = (pr.vendor || '');
              var pe = $('[data-bprice]', c); if (pe) pe.textContent = money(price);
              var sel = $('[data-bvariant]', c);
              if (sel) {
                if (vs.length > 1) {
                  sel.innerHTML = '';
                  vs.forEach(function (v) {
                    var o = document.createElement('option');
                    o.value = v.id; o.dataset.price = Math.round(parseFloat(v.price) * 100);
                    o.textContent = v.title + ' — ' + money(o.dataset.price);
                    sel.appendChild(o);
                  });
                } else { sel.remove(); }
              }
              var a = $('[data-badd]', c), qb = $('[data-bqty]', c), ce = $('[data-bcount]', c);
              if (a) a.hidden = false; if (qb) qb.hidden = true; if (ce) ce.textContent = '1';
              grid.appendChild(c);
              cards.push(c);
              initCard(c);
              var sid = root.dataset.setIds || '';
              root.dataset.setIds = sid ? sid + ',' + v0.id : String(v0.id);
              setIds = root.dataset.setIds.split(',');
            });
            if (list.length === 250) return addPage(p + 1);
          })
          .catch(function () {});
      }
      addPage(1).then(function () {
        var ev = new Event('resize'); window.dispatchEvent(ev);
      });
    })();
    on(document, 'cart:updated', loadCart);
  }

  function init() {
    if (window.matchMedia('(max-width:1100px)').matches && body.dataset.motionMobileOff === 'true') body.classList.remove('anim-on');
    reveal(); menu(); search(); hero(); rows(); tabs(); accordions(); qtyWidgets();
    bindCart(); cartForms(); variants(); gallery(); toTop(); filters(); bundleBuilder();
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('shopify:section:load', function () {
      reveal(); hero(); rows(); tabs(); accordions(); qtyWidgets(); bindCart(); cartForms(); variants(); gallery(); bundleBuilder();
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

document.addEventListener('change', function(e){
  if (e.target.matches('[data-consent-check]')) {
    var scope = e.target.closest('form') ? e.target.closest('form').parentElement : document;
    var btn = (scope.querySelector && scope.querySelector('[data-checkout-btn]')) || document.querySelector('[data-checkout-btn]');
    if (btn) btn.disabled = !e.target.checked;
  }
});
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-consent-check]').forEach(function(cb){
    var scope = cb.closest('form') ? cb.closest('form').parentElement : cb.parentElement.parentElement;
    var btn = scope.querySelector('[data-checkout-btn]');
    if (btn) btn.disabled = !cb.checked;
  });
});

/* Shopify Inbox balonunu ödülün (40) altına indir — seçici değişse de bulur */
(function(){
  var SEL = '#shopify-chat,[id^="ShopifyChat"],[id*="chat-button"],[class*="shopify-chat"],shopify-chat,iframe[name*="chat"],iframe[title*="ohbet"],iframe[title*="hat"]';
  function fix(){
    document.querySelectorAll(SEL).forEach(function(el){
      var n = el;
      // sabit konumlu en dış kabı bul
      while (n && n !== document.body && getComputedStyle(n).position !== 'fixed') n = n.parentElement;
      (n && n !== document.body ? n : el).style.setProperty('z-index','39','important');
    });
  }
  fix();
  new MutationObserver(fix).observe(document.body, {childList:true, subtree:true});
  setTimeout(fix, 2000); setTimeout(fix, 5000);
})();
